/**
 * @generated SignedSource<<10140cbcc87c3647b34ee8a41dafaebf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_rankField$data = {
  readonly rankField?: {
    readonly aliases: ReadonlyArray<string> | null | undefined;
    readonly jqlTerm: string;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_ListView_rankField";
};
export type main_issueNavigator_ListView_rankField$key = {
  readonly " $data"?: main_issueNavigator_ListView_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_rankField",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraJqlFieldWithAliases",
          "kind": "LinkedField",
          "name": "rankField",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jqlTerm"
            },
            {
              "kind": "ScalarField",
              "name": "aliases"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "1f7fb5400c49be35b17fe142cd30bec1";

export default node;
